import { render } from "./PaginationBtns.vue?vue&type=template&id=509fe165&scoped=true"
import script from "./PaginationBtns.vue?vue&type=script&lang=js"
export * from "./PaginationBtns.vue?vue&type=script&lang=js"

import "./PaginationBtns.vue?vue&type=style&index=0&id=509fe165&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509fe165"]])

export default __exports__